/**
 * getClosestDay()
 * @param {[XXXX-XX-XXTXX:XX:XX.XXXZ]} dates Array of dates strings.
 * @returns The closest date between a list of dates.
 */
export default function getClosestDay(
  dates: string[] | undefined,
): Date | undefined {
  if (!dates) return;

  const nowDate = new Date();
  const MAX_TIMESTAMP = 8640000000000000;
  let closestDate = new Date(MAX_TIMESTAMP);

  dates.forEach((dateString: string) => {
    const date = new Date(dateString);

    if (date >= nowDate && date < new Date(closestDate)) {
      closestDate = date;
    }
  });

  return closestDate;
}
